import React, { useState, useEffect } from 'react';
import { Card, InputNumber, Button, message, Spin, Typography } from 'antd';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';

const { Title } = Typography;

interface DatosFijosResponse {
  valor_numerico: string | null;
}

const CantidadFLotes: React.FC = () => {
  const [valorCLO, setValorCLO] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [actualizando, setActualizando] = useState<boolean>(false);
  const { getAccessTokenSilently, user } = useAuth0();

  const cargarDatosFijos = async () => {
    if (!user?.id_empresa) return;
    const id_sucursal = user?.id_sucursal;
    
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const response = await axios.get<DatosFijosResponse[]>(
        `${process.env.REACT_APP_RELACION_URL}/leer_datos_fijos/${user.id_empresa}/${id_sucursal}/CLO`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      console.log('Respuesta del servidor:', response.data);
      
      // Acceder al primer elemento del array
      const datosFijos = response.data[0];
      console.log('Datos fijos:', datosFijos);
      
      // Si el valor es null o vacío, establecer 0
      const valorNumerico = datosFijos?.valor_numerico;
      console.log('Valor numérico recibido:', valorNumerico);
      
      if (valorNumerico) {
        const valorConvertido = parseFloat(valorNumerico);
        console.log('Valor convertido:', valorConvertido);
        setValorCLO(valorConvertido);
      } else {
        console.log('Valor nulo o vacío, estableciendo 0');
        setValorCLO(0);
      }
    } catch (error) {
      console.error('Error al cargar los datos fijos:', error);
      message.error('Error al cargar los datos fijos');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarDatosFijos();
  }, [user?.id_empresa, getAccessTokenSilently]);

  const handleActualizar = async () => {
    if (!user?.id_empresa) return;
    const id_sucursal = user?.id_sucursal;

    try {
      setActualizando(true);
      const token = await getAccessTokenSilently();
      
      console.log('Valor a enviar:', valorCLO);
      
      await axios.post(
        `${process.env.REACT_APP_RELACION_URL}/grabar_datos_fijos/${user.id_empresa}/${id_sucursal}/CLO/${'a'}/${valorCLO}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      message.success('Valor actualizado correctamente');
      cargarDatosFijos(); // Recargar los datos después de actualizar
    } catch (error) {
      console.error('Error al actualizar el valor:', error);
      message.error('Error al actualizar el valor');
    } finally {
      setActualizando(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Card
      style={{ margin: '20px' }}
      headStyle={{ backgroundColor: '#1890ff', color: 'white' }}
      title={
        <div style={{ 
          textAlign: 'center', 
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <Title level={4} style={{ color: 'white', margin: 0 }}>
            Cantidad de Fardos por Lote
          </Title>
        </div>
      }
    >
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        gap: '20px',
        padding: '20px'
      }}>
        <div style={{ 
          backgroundColor: '#f0f9f0',
          padding: '20px',
          borderRadius: '8px',
          width: '100%',
          maxWidth: '400px',
          textAlign: 'center'
        }}>
          <Title level={5}>Valor Actual</Title>
          <InputNumber
            value={valorCLO}
            onChange={(value) => setValorCLO(value || 0)}
            style={{ width: '200px', marginTop: '10px' }}
            min={0}
            precision={2}
            step={0.01}
          />
        </div>

        <Button
          type="primary"
          onClick={handleActualizar}
          loading={actualizando}
          style={{ 
            width: '200px',
            height: '40px',
            fontSize: '16px'
          }}
        >
          Actualizar
        </Button>
      </div>
    </Card>
  );
};

export default CantidadFLotes; 